import { useEffect, useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
// import { Link } from 'react-router-dom';
import img_header from '../../assets/images/header-events.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faSquareInstagram } from '@fortawesome/free-brands-svg-icons';
import Slider from "react-slick";
import dayjs from "dayjs";

function ContentEvents() {
    const [galleryData, setGalleryData] = useState([]);
    const [open, setOpen] = useState(false);
    // const [loading, setLoading] = useState(true);
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        const loadGallery = async () => {
            try {
                const res = await fetch(`/data-web-compro/json/gallery-news.json?t=` + Date.now());

                if (!res.ok) {
                    throw new Error("Failed to fetch news");
                }

                const data = await res.json();

                setGalleryData(data);
            } catch (err) {
                console.error('Error fetching catalog:', err);
                // } finally {
                //     setLoading(false);
            }
        };

        loadGallery();
    }, []);

    const handleImageClick = (img) => {
        setSelectedImage(img);
        setOpen(true);
    };

    const closePopup = () => {
        setOpen(false);
    };

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    centerMode: true,
                    centerPadding: '0',
                    slidesToScroll: 1,
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 430,
                settings: {
                    dots: false,
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToScroll: 1,
                    slidesToShow: 1
                }
            }
        ]
    };

    const LIMIT = 5;

    const [newsData, setNewsData] = useState([]);
    const [visible, setVisible] = useState(LIMIT);

    useEffect(() => {
        const loadNews = async () => {
            try {
                const res = await fetch("/data-web-compro/json/news.json?t=" + Date.now());

                if (!res.ok) {
                    throw new Error("Failed to fetch news");
                }

                const data = await res.json();
                setNewsData(data);

            } catch (err) {
                console.error(err);
                // } finally {
                //     setLoading(false);
            }
        };

        loadNews();
    }, []);


    const handleLoadMore = () => {
        setVisible((prev) => prev + LIMIT);
    };

    const isAllLoaded = visible >= newsData.length;
    // if (loading) return <p>Loading news...</p>;

    return (
        <div>
            <div className="pt-[50px] md:pt-[64px] bg-[#F1F8FF]">
                <img src={img_header} className="w-100" alt="FamilyMart Indonesia" />
            </div>
            <div className="px-[15px] md:px-[50px] lg:px-[70px] xl:px-[100px] mb-[50px]">
                <div>
                    <h3 className="text-2xl md:text-5xl text-sky-500 text-center font-extrabold mt-5">Event & Activities</h3>
                    <h3 className="text-lg md:text-xl text-black-500 text-center mt-3 mb-5">Ikuti Keseruan FamilyMart.</h3>
                </div>

                {newsData.slice(0, visible).map((item) => (
                    <div key={item.id}>
                        <div className="w-full bg-white rounded-2xl shadow-lg mb-5 p-4 border-2 border-black-500">
                            <div className="grid grid-cols-1 md:grid-cols-5">
                                <div className="flex items-center mb-5 md:mb-0">
                                    <img
                                        src={item.image}
                                        alt="FamilyMart Indonesia"
                                        className="rounded-2xl h-48 w-full object-cover"
                                    />
                                </div>
                                <div className="col-span-4">
                                    <div className="px-0 md:px-5">
                                        <div className="flex flex-row gap-4 text-[#5A5555] mb-2">
                                            <div className="rounded-2xl bg-[#FFF] border-2 px-2">
                                                <span className="text-sm">{dayjs(item.publish_date).format('dddd, D MMMM YYYY')}</span>
                                            </div>
                                            <div className="rounded-2xl bg-[#FFF] border-2 px-2">
                                                <span className="text-sm">{item.category}</span>
                                            </div>
                                        </div>
                                        <h3 className="text-xl font-semibold text-gray-800 mb-2">
                                            {item.title}
                                        </h3>
                                        <span className="text-sm text-[#5A5555]"><FontAwesomeIcon icon={faLocationDot} /> {item.location}</span>
                                        <p className="text-sm mt-2 mb-4 text-justify">
                                            {item.news_detail}
                                        </p>
                                        <div className="flex flex-row gap-4 text-[#5A5555]">
                                            <div className="rounded-2xl bg-[#FFF] border-2 px-2">
                                                <a href={item.instagram_link} target='_blank'><FontAwesomeIcon icon={faSquareInstagram} /> <span className="text-sm text-sky-500">Instagram</span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                {!isAllLoaded && (
                    <button className='text-center w-full bg-white rounded-2xl shadow-lg border-2 border-black-500 mb-5 text-sm' onClick={handleLoadMore}>
                        See More
                    </button>
                )}
            </div>
            {/*
            <div className="px-[15px] md:px-[50px] lg:px-[70px] xl:px-[100px]">
                <div>
                    <h3 className="text-xl md:text-3xl text-sky-500 font-extrabold my-5">Galleries</h3>
                    <Slider className="px-0 xl:px-[60px]" {...settings}>
                        {galleryData.map((item) => {
                            // if (index > 1) return null;

                            return (
                                <div className="p-1 xl:p-5" key={item.id} > <img className="rounded-2xl h-[222px] w-full object-cover" src={item.image} alt={item.image} onClick={() => handleImageClick(item.image)} /></div>
                            );
                        })}
                    </Slider >

                    <Dialog.Root open={open} onOpenChange={setOpen}>
                        <Dialog.Portal>
                            <Dialog.Overlay className="fixed inset-0 bg-black/80 z-40" />
                            <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 p-4 rounded shadow-xl max-w-5xl w-full">
                                <Dialog.Title>
                                    <VisuallyHidden>Image Preview</VisuallyHidden>
                                </Dialog.Title>
                                <Dialog.Description>
                                    <VisuallyHidden>Image Description</VisuallyHidden>
                                </Dialog.Description>
                                
                                <div className="absolute inset-0" onClick={closePopup}></div>
                                <button
                                    onClick={closePopup}
                                    className="absolute top-4 right-4 z-20 text-white text-3xl font-bold"
                                >
                                    &times;
                                </button>
                                <img
                                    src={selectedImage}
                                    alt={`Zoomed`}
                                    className="w-full object-contain max-h-screen mx-auto"
                                />
                            </Dialog.Content>
                        </Dialog.Portal>
                    </Dialog.Root>
                </div>
            </div>
            */}
        </div>
    );
}

export default ContentEvents;
